import React, {Component} from 'react';
import Toast from "../Common/Toast";
import LogoPic from "../../assets/images/logo.png";
import API from "../../services/API";
import {toast} from "react-toastify";
import Loading from "../Common/Loading";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Register extends Component {
    state= {
        carCode : '',
        carName : '',
        mobile : '',
        mobile2 : '',
        sim : '',
        password : '',
        sysType: true,
        isLoaded: true,
    }
    onInputChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        if (name === 'mobile' || name === 'mobile2' || name === 'sim' ) {
            if (value.length >= 12) {
                return false;
            }
        }
        this.setState({[name] :value });
    }

    sendToSocket = () => {
        let value = this.state.mobile;
        if (value[0] !== '0' || value[1] !== '9' || value.length !== 11) {
            toast.error('شماره سیمکارت ۱ موبایل را درست وارد کنید');
            return false;
        }
        value = this.state.sim;
        if (value[0] !== '0' || value[1] !== '9' || value.length !== 11) {
            toast.error('شماره سیمکارت دستگاه را درست وارد کنید');
            return false;
        }
        value = this.state.carCode;
        if (value.length < 5) {
            toast.error('کد  دستگاه را درست وارد کنید');
            return false;
        }
        value = this.state.password;
        if (value.length < 4) {
            toast.error('پسورد   را درست وارد کنید');
            return false;
        }
        this.setState({
            isLoaded: false,
        })
            const request = {
                'mobile': this.state.mobile,
                'device': this.state.carCode,
                'password': this.state.password,
                'command': 'sav-' + this.state.sim
            };

            API.socketRegister(request)
                .then((response) => {
                    this.setState({
                        isLoaded: true,
                    })
                    if(response.data.success === 1) {
                        toast.success(response.data.message);
                        const request = {
                            'use': this.state.mobile,
                            'car_code': this.state.carCode,
                            'pas': this.state.password,
                            'name': this.state.carName,
                            'phone_device': this.state.sim,
                            'phone2': this.state.mobile2,
                        };
                        API.SaveCar(request)
                            .then((response) => {
                                window.localStorage.setItem("mobile", this.state.mobile);
                                window.localStorage.setItem("password", this.state.password);
                                window.localStorage.setItem("connection_type", 'internet');
                                setTimeout(() => {
                                    window.location.replace("/home");
                                }, 2500)
                            })
                    }
                    else {

                        toast.warning(response.data.message);
                        if(response.data.data.type === "duplicate") {
                            window.localStorage.setItem("mainMobile", response.data.data.mobile);
                            setTimeout(() => {
                                this.props.history.push("/login");
                            }, 2500)
                        }

                    }
                })
                .catch((error) => {
                    this.setState({
                        isLoaded: true,
                    })
                });

    }

    render() {
        return (
            <React.Fragment>
                {
                    !this.state.isLoaded && <Loading />
                }

                <section className="container mt-5 pt-5 max-w-lg login-window">
                    <div className="row text-center mt-4">
                        <Toast  />
                        <div className="col-12 pt-1 mb-3">
                            <img src={LogoPic} alt="سامانه پروماتیکس" className="rounded mx-auto d-block mt-2   " width='70' />
                        </div>
                        <div className="col-12 mt-0 text-center text-primary-color fw-bold mb-5  ">
                            ثبت نام
                        </div>






                      {/*  <div className="col-12 rtl mb-3">
                            <div className="row mx-1 mt-3">
                                <div className="col-5 zone-wire "
                                     style={this.state.sysType ? {backgroundColor: '#7873A2'} : {}}
                                     onClick={() => {
                                         this.setState({sysType: 1})
                                     }}
                                >
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault"
                                               checked={this.state.sysType} readOnly/>
                                        <label className="form-check-label text-white" htmlFor="inlineRadio1">
                                            ردیاب
                                            (TCN-V200)
                                            </label>
                                    </div>


                                </div>
                                <div className="col-2">
                                    &nbsp;
                                </div>
                                <div className="col-5 zone-wire"
                                     style={!this.state.sysType ? {backgroundColor: '#7873A2'} : {}}
                                     onClick={() => {
                                         this.setState({sysType: 0})
                                     }}
                                >
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault"
                                               checked={!this.state.sysType} readOnly/>
                                        <label className="form-check-label text-white" htmlFor="inlineRadio2">
                                            ردیاب-دزدگیر
                                            (TCN-V300)
                                            </label>
                                    </div>

                                </div>


                            </div>
                        </div>*/}

                        <div className="col-12 mt-2 mb-4">
                            <span className='btn btn-outline-info text-small-2'
                                  onClick={
                                      () => this.props.history.push('/login')
                                  }
                            >
                                <FontAwesomeIcon icon={faArrowLeft} className='mx-2'/>
                                قبلا ثبت نام کرده اید؟ ورود با شماره موبایل و پسورد

                            </span>
                        </div>
                        <div className="col-12 my-2 text-right small text-color  mt-10">
                            <div className="form-floating mb-3">
                                <div className="form-floating mb-3">
                                    <input type="text"
                                           className="form-control text-center text-big-2 "
                                           id="carCode"
                                           name="carCode"
                                           placeholder=" کد پشت دستگاه "
                                           value={this.state.carCode}
                                           onChange={this.onInputChange}
                                    />
                                    <label htmlFor="carCode" className="right-0">
                                    کد پشت دستگاه
                                    </label>
                                </div>
                            </div>

                            <div className="form-floating mb-3">
                                <div className="form-floating mb-3">
                                    <input type="text"
                                           className="form-control text-center text-big-2 "
                                           id="carName"
                                           name="carName"
                                           placeholder=" نام خودرو "
                                           value={this.state.carName}
                                           onChange={this.onInputChange}
                                    />
                                    <label htmlFor="carName" className="right-0">
                                        نام خودرو
                                    </label>
                                </div>
                            </div>

                            <div className="form-floating mb-3">
                                <input type="tel"
                                       className="form-control text-center text-big-2 "
                                       id="mobile"
                                       name="mobile"
                                       placeholder="   شماره سیم کارت ۱ موبایل "
                                       value={this.state.mobile}
                                       onChange={this.onInputChange}
                                />
                                <label htmlFor="mobile" className="right-0">
                                شماره سیم کارت ۱ موبایل
                                </label>
                            </div>
                            <div className="form-floating mb-3">
                                <input type="tel"
                                       className="form-control text-center text-big-2 "
                                       id="mobile2"
                                       name="mobile2"
                                       placeholder="   شماره سیم کارت 2 موبایل "
                                       value={this.state.mobile2}
                                       onChange={this.onInputChange}
                                />
                                <label htmlFor="mobile2" className="right-0">
                                شماره سیم کارت 2 موبایل
                                </label>
                            </div>
                            <div className="form-floating mb-3">
                                <input type="tel"
                                       className="form-control text-center text-big-2 "
                                       id="sim"
                                       name="sim"
                                       placeholder="   شماره سیم کارت دستگاه "
                                       value={this.state.sim}
                                       onChange={this.onInputChange}
                                />
                                <label htmlFor="sim" className="right-0">
                                شماره سیم کارت دستگاه
                                </label>
                            </div>
                            <div className="form-floating mb-3">
                                <input type="tel"
                                       className="form-control text-center text-big-2 "
                                       id="password"
                                       name="password"
                                       placeholder="  پسورد "
                                       value={this.state.password}
                                       onChange={this.onInputChange}
                                />
                                <label htmlFor="password" className="right-0">
                                پسورد
                                </label>
                            </div>

                        </div>
                        <div className="col-12">
                            <button className='btn btn-success w-100'
                                    onClick={
                                        this.sendToSocket
                                    }
                            >
                                ثبت نام
                            </button>
                        </div>

                    </div>
                </section>

            </React.Fragment>
        );
    }
    componentDidMount() {
        const mobile = window.localStorage.getItem("mobile");
        const password = window.localStorage.getItem("password");

        if(mobile && password ) {
            window.location.replace('/home')
        }
    }
}

export default Register;